export const getISODayWithoutHours = (value: Date) => {
  const d = new Date(value).setUTCHours(0, 0, 0, 0);
  const result = new Date(d).toISOString();

  return result;
};
